module.exports = __webpack_public_path__ + "static/media/attraction1.b7f6a2cb.jpg";